export const selectModal = state => state.modalReducer.isModalOpen;